import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border bg-white rounded-3 overflow-hidden mb-4" }
const _hoisted_2 = { style: {"margin":"-45px -11px -31px -15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex align-items-center p-4 pb-3 mb-1\"><div class=\"flex-shrink-0\"><div class=\"wh-55 bg-danger bg-opacity-25 text-center rounded-2\" style=\"line-height:55px;\"><i class=\"ri-money-dollar-circle-line fs-22 bg-danger text-white rounded-2 p-2\"></i></div></div><div class=\"flex-grow-1 ms-3\"><h3 class=\"fs-24 fw-medium mb-0\">$250,000</h3><span>Total Revenue</span></div></div><div class=\"d-flex align-items-center p-4 pb-0\"><span class=\"d-inline-block bg-success text-success bg-opacity-10 border border-success rounded-pill px-2 fw-medium d-flex align-items-center\"><i class=\"ri-arrow-up-fill fs-16 lh-1\"></i> 12% </span><span class=\"ms-2 fs-12\">from last week</span></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isClient)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            type: "line",
            height: "120",
            options: _ctx.totalRevenue,
            series: _ctx.revenue
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true)
    ])
  ]))
}